import { Lookup } from './lookup';

export class ShipmentLookup {
  cancellationReasons: Lookup[];
  fitsIn: Lookup[];
  modes: Lookup[];
}
